import { requiredString } from "components/form/utils";
import { z } from "zod";

export const extensionSchema = z.object({
  billing_date: requiredString(),
  justification: requiredString(),
});
